// extracted by css-extract-rspack-plugin
export default {"root":"root-BTRwgX","withContent":"withContent-estGRj","title":"title-ujZHQp"};